"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

function defaultOptions(options) {
  return __assign({
    dedent: false,
    indent: false,
    next: null,
    pop: null,
    push: null
  }, options);
}

var LanguageRule =
/** @class */
function () {
  function LanguageRule(token, regex, options) {
    this.options = defaultOptions(options);
    this.regex = regex;
    this.token = token;
  }

  LanguageRule.create = function (token, regex, options) {
    return new LanguageRule(token, regex, options || {});
  };

  LanguageRule.prototype.getRule = function () {
    return {
      dedent: this.options.dedent,
      indent: this.options.indent,
      regex: this.regex,
      token: this.token
    };
  };

  return LanguageRule;
}();

exports.LanguageRule = LanguageRule;